/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { AllasStandaloneContentLock as ResolvedStandaloneContentLock } from 'sites/allas/components/standalone/ContentLock';

export const ContentLock: typeof ResolvedStandaloneContentLock = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneContentLock {...props} />
    );
});

export type ContentLockProps = PropsFromComponent<typeof ContentLock>;

/** @deprecated Use slot architecture instead */
export const ContentLockWith = (extras: DynamicStandaloneExtras): typeof ContentLock => {
    return function ContentLock(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ContentLock');
        return <ResolvedStandaloneContentLock {...mergeProps({ options: { theme } }, props)} />;
    }
}